import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b6d5cf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tvBox" }
const _hoisted_2 = { class: "tvBox_box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag_bg" }, null, -1))
const _hoisted_6 = { class: "drag_text" }

import { ref, reactive, nextTick } from "vue";
import { getImgSwipe, rstImgSwipe } from "@/api/index";
import { ElMessage } from "element-plus";

export default {
  __name: 'check',
  emits: ['success'],
  setup(__props, { emit }) {


/*距离屏幕左端距离*/
const beginClientX = ref(0);
/*触发拖动状态  判断*/
const mouseMoveState = ref(false);
/*拖动最大宽度，依据滑块宽度算出来的*/
const maxWidth = ref('');
/*滑块文字*/
const confirmWords = ref('');
/*验证成功判断*/
const confirmSuccess = ref(false);
// 是否显示划动验证
const isShowTest = ref(false);

// mouseleave
const mouseleaveHandle = () => {
  if (!mouseMoveState.value) {
    isShowTest.value = false
  }
};


//mousedown 事件
const mouseDownFn = (e) => {
    if(!confirmSuccess.value){
        e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
        mouseMoveState.value = true;
        beginClientX.value = e.clientX;
    };
};
//验证成功函数
const successFunction = (width) => {
  beginClientX.value = 0;
  rstImgSwipe({
    captchaSerialNumber: imgSwipe.value.captchaSerialNumber,
    moveEnd_X: width,
    wbili: 1
  }).then(res => {
    if (res.data == 1) {
      confirmSuccess.value = true;
      confirmWords.value = '';
      if(window.addEventListener){
          document.getElementsByTagName('html')[0].removeEventListener('mousemove',mouseMoveFn);
          document.getElementsByTagName('html')[0].removeEventListener('mouseup', moseUpFn);
      }else {
          document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
      }
      document.getElementsByClassName('handler')[0].style.left = width + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
      emit('success', {flag: true, imgSwipe: imgSwipe.value, width});
    } else if (res.data == 0) {
      document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      imgS.value.style.left = `0px`;
      ElMessage.error('验证失败');
    } else {
      document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      imgS.value.style.left = `0px`;
      ElMessage.error('验证失败');
      getImgSwipeM();
    };
  });
};
//mousemove事件
const mouseMoveFn = (e) => {
  if(mouseMoveState.value){
    let width = e.clientX - beginClientX.value;
    if(width >= 0 && width <= maxWidth.value){
      imgS.value.style.left = `${width}px`;
      document.getElementsByClassName('handler')[0].style.left = width + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
    };
  };
};
//mouseup事件
const moseUpFn = (e) => {
  mouseMoveState.value = false;
  var width = e.clientX - beginClientX.value;
  if (beginClientX.value) {
    successFunction(width);
  };
};


const dragDiv = ref(null);
const moveDiv = ref(null);
nextTick(() => {
    maxWidth.value = dragDiv.value.clientWidth - moveDiv.value.clientWidth;
    document.getElementsByTagName('html')[0].addEventListener('mousemove',mouseMoveFn);
    document.getElementsByTagName('html')[0].addEventListener('mouseup',moseUpFn)
})


// 划动验证
const imgSwipe = ref({});
const imgS = ref(null);
const imgB = ref(null);
const getImgSwipeM = () => {
  getImgSwipe().then(res => {
    imgSwipe.value = res.data;
    imgS.value.style.top = `${res.data.yposition}px`;
  });
};
getImgSwipeM();

return (_ctx, _cache) => {
  const _component_DArrowRight = _resolveComponent("DArrowRight")
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")

  return (_openBlock(), _createElementBlock("div", {
    class: "drag",
    ref_key: "dragDiv",
    ref: dragDiv
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          ref_key: "imgS",
          ref: imgS,
          class: "imgS",
          src: `data:image/png;base64,${imgSwipe.value.cutImage}`,
          alt: "加载失败"
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          ref_key: "imgB",
          ref: imgB,
          class: "imgB",
          src: `data:image/png;base64,${imgSwipe.value.srcImage}`,
          alt: "加载失败"
        }, null, 8, _hoisted_4)
      ])
    ], 512), [
      [_vShow, isShowTest.value]
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, _toDisplayString(confirmWords.value), 1),
    _createElementVNode("div", {
      ref_key: "moveDiv",
      ref: moveDiv,
      onMouseenter: _cache[0] || (_cache[0] = $event => {isShowTest.value = true;}),
      onMouseleave: mouseleaveHandle,
      onMouseup: _cache[1] || (_cache[1] = $event => {isShowTest.value = false;}),
      onMousedown: _cache[2] || (_cache[2] = $event => (mouseDownFn($event))),
      class: _normalizeClass([{'handler_ok_bg':confirmSuccess.value}, "handler handler_bg"]),
      style: {"position":"absolute","top":"0px","left":"0px"}
    }, [
      (!confirmSuccess.value)
        ? (_openBlock(), _createBlock(_component_DArrowRight, {
            key: 0,
            style: {"width":"20px","height":"20px","margin-top":"15px"},
            color: "#9EA4A5"
          }))
        : _createCommentVNode("", true),
      (confirmSuccess.value)
        ? (_openBlock(), _createBlock(_component_SuccessFilled, {
            key: 1,
            style: {"width":"20px","height":"20px","margin-top":"15px"},
            color: "#93D8F5"
          }))
        : _createCommentVNode("", true)
    ], 34)
  ], 512))
}
}

}